import axios from 'axios';
import { getColivingsApiBaseUrl } from '@/utils/apiBaseUrl';

/**
 * Lectura rápida del snapshot hub (/api/colivings/search-hub).
 * 404 = miss → el caller usa searchProperties.
 */
export async function tryFetchHubListSnapshot(params) {
  const base = getColivingsApiBaseUrl();
  const url = `${base}/colivings/search-hub`;
  try {
    const { data } = await axios.get(url, {
      params: {
        region: params.region || 'es',
        pageSize: params.pageSize || 12,
        page: params.page || 1,
        sortBy: params.sortBy || 'market_relevance',
      },
      timeout: 2000,
      signal: params.signal,
    });
    if (data?.results && Array.isArray(data.results)) return data;
    return null;
  } catch (err) {
    if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') throw err;
    return null;
  }
}
